import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Training Institute Target")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-4" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_15 = { class: "col-md-2 mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Training Institute Target List", -1)
const _hoisted_18 = { class: "card mb-5 mb-xl-10" }
const _hoisted_19 = {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_20 = { class: "row mt-1 w-100 m-0" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "text",
      class: "form-control ps-10 w-200px mt-1 form-control-sm",
      style: {"height":"1em"},
      placeholder: "Search"
    })
  ])
], -1)
const _hoisted_22 = { class: "row w-100 mb-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_24 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_32 = { class: "collapse show" }
const _hoisted_33 = { class: "card-body border-top p-6" }
const _hoisted_34 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { key: 3 }
const _hoisted_39 = { key: 4 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 0,
  class: "fas text-light fa-pencil-alt"
}
const _hoisted_42 = {
  key: 1,
  class: "fas text-light fa fa-plus"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!
  const _component_TargetDrawer = _resolveComponent("TargetDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Form, {
      onSubmit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.formSubmit())),
      class: "form",
      "validation-schema": _ctx.AssociationSchema
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _hoisted_10,
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.batch.tranche_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                        options: _ctx.optionsTranche,
                        mode: "tags",
                        "clear-on-select": false,
                        placeholder: "Select Tranche",
                        "close-on-select": false,
                        searchable: true,
                        "create-option": true
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.batch.entity_id,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                        options: _ctx.optionsTPartner,
                        mode: "tags",
                        "clear-on-select": false,
                        placeholder: "Select Training Partner",
                        "close-on-select": false,
                        searchable: true,
                        "create-option": true
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Institute",
                        modelValue: _ctx.batch.institute_id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: info.id,
                              label: info.institute_name,
                              value: info.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(info.institute_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.courseInfo && _ctx.courseInfo(...args))),
                        type: "button",
                        class: "btn btn-success mt-6 p-3",
                        style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                      }, [
                        _createTextVNode(" Search "),
                        _hoisted_16
                      ])
                    ])
                  ]),
                  (_ctx.showCourseNotice == true)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: _ctx.componentKey,
                        class: "mt-5"
                      }, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _hoisted_21,
                              _createElementVNode("div", _hoisted_22, [
                                _hoisted_23,
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                    title: "Download Xlse",
                                    "data-v-54b12dc8": "",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportTrainee()))
                                  }, _hoisted_26),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                    title: "Download PDF",
                                    "data-v-54b12dc8": "",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadPdf()))
                                  }, _hoisted_28),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                    title: "Print",
                                    "data-v-54b12dc8": "",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printPdf()))
                                  }, _hoisted_30)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createVNode(_component_Datatable, {
                                    "table-data": _ctx.courseList,
                                    "table-header": _ctx.tableHeader,
                                    "enable-items-per-page-dropdown": true
                                  }, {
                                    "cell-course": _withCtx(({ row: industry }) => [
                                      _createTextVNode(_toDisplayString(industry?.course_info?.course_name), 1)
                                    ]),
                                    "cell-institute": _withCtx(({ row: industry }) => [
                                      _createTextVNode(_toDisplayString(industry?.institute_info?.institute_name), 1)
                                    ]),
                                    "cell-target_trainee": _withCtx(({ row: industry }) => [
                                      _createTextVNode(_toDisplayString(industry?.institute_target_details
                                  ?.total_target_trainee), 1)
                                    ]),
                                    "cell-status": _withCtx(({ row: industry }) => [
                                      (industry?.institute_target_details
                                  ?.active_status == 0
                                )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString('Pending')))
                                        : _createCommentVNode("", true),
                                      (industry?.institute_target_details
                                  ?.active_status == 1
                                )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString('Active')))
                                        : _createCommentVNode("", true),
                                      (industry?.institute_target_details
                                  ?.active_status == 3
                                )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString('Inactive')))
                                        : _createCommentVNode("", true),
                                      (industry?.institute_target_details
                                  ?.active_status == 2
                                )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString('Reject')))
                                        : _createCommentVNode("", true),
                                      (industry?.institute_target_details
                                  ?.active_status == 4
                                )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString('Suspend')))
                                        : _createCommentVNode("", true)
                                    ]),
                                    "cell-batch_size": _withCtx(({ row: industry }) => [
                                      _createTextVNode(_toDisplayString(industry?.course_info?.trainee_per_batch), 1)
                                    ]),
                                    "cell-of_batch": _withCtx(({ row: industry }) => [
                                      _createTextVNode(_toDisplayString(industry?.course_info?.total_target_batches), 1)
                                    ]),
                                    "cell-actions": _withCtx(({ row: industry }) => [
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (_ctx.edit(industry)),
                                        "data-kt-drawer-toggle": "true",
                                        "data-kt-drawer-target": "#kt_modal_institute_target",
                                        id: "kt_modal_institute_target_button",
                                        class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                      }, [
                                        (industry?.institute_target_details)
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_41))
                                          : (_openBlock(), _createElementBlock("i", _hoisted_42))
                                      ], 8, _hoisted_40)
                                    ]),
                                    _: 1
                                  }, 8, ["table-data", "table-header"])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.load]
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      ]),
      _: 1
    }, 8, ["validation-schema"]),
    _createVNode(_component_TargetDrawer)
  ], 64))
}